import { alpha } from '@mui/material/styles';
import { gray } from '../themePrimitives';

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const severity = ownerState.severity || 'info';
        const palette = theme.palette[severity] || theme.palette.info;
        return {
          borderRadius: 10,
          backgroundColor: palette.lighter || palette.light,
          color: (theme.vars || theme).palette.text.primary,
          border: `1px solid ${alpha(palette.main, 0.5)}`,
          '& .MuiAlert-icon': {
            color: palette.main,
          },
          ...theme.applyStyles('dark', {
            backgroundColor: `${alpha(palette.dark, 0.5)}`,
            border: `1px solid ${alpha(palette.dark, 0.5)}`,
          }),
        };
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
